<div class="budget-item" [class.last]="isLast()">
  <span class="description">{{ item().description }}</span>
  <span class="amount">
    @if(item().isDiscount){
      <span class="minus">- </span>
    }
    {{ item().amount }}
  </span>
</div>
